import React, { useState } from 'react';
import { INVALIDATE_CACHE } from '../mutations';
import { CACHE_CREDENTIALS_RESET, CACHE_CONFIGURATIONS_RESET } from '../subscriptions';
import { useMutation, useConditionalSubscription } from '../../common/security/hooks';
import { useToast, useSimpleError } from 'hooks';
import InvalidateCacheComponent from './InvalidateCacheComponent';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

const InvalidateCacheContainer = () => {
  const { t } = useTranslation();
  const addToast = useToast();
  const showError = useSimpleError();
  const [invalidateCredentialsDisabled, setInvalidateCredentialsDisabled] = useState(false);
  const [invalidateConfigurationsDisabled, setInvalidateConfigurationsDisabled] = useState(false);

  const [invalidateCache] = useMutation(INVALIDATE_CACHE, {
    setCorrelation: true,
    onError: error => showError(error)
  });

  useConditionalSubscription(CACHE_CREDENTIALS_RESET, {
    onData: ({ data: { data } }) => {
      if (data.cacheCredentialsReset.errorMessage) {
        showError(data.cacheCredentialsReset.errorMessage);
      }
      if (data.cacheCredentialsReset.success) {
        addToast(t('Settings.InvalidateCache.CredentialsInvalidated'), 'info', { toastId: 'cacheCredentialsResetToast' });
      }
      setInvalidateCredentialsDisabled(false);
    }
  });

  useConditionalSubscription(CACHE_CONFIGURATIONS_RESET, {
    onData: ({ data: { data } }) => {
      if (data.cacheConfigurationsReset.errorMessage) {
        showError(data.cacheConfigurationsReset.errorMessage);
      }
      if (data.cacheConfigurationsReset.success) {
        addToast(t('Settings.InvalidateCache.ConfigurationsInvalidated'), 'info', { toastId: 'cacheConfigurationsResetToast' });
      }
      setInvalidateConfigurationsDisabled(false);
    }
  });

  const handleInvalidateCredentials = useCallback(() => {
    setInvalidateCredentialsDisabled(true);
    invalidateCache({ variables: { input: { invalidateCredentials: true } } });
  }, [invalidateCache]);

  const handleInvalidateConfigurations = useCallback(() => {
    setInvalidateConfigurationsDisabled(true);
    invalidateCache({ variables: { input: { invalidateConfigurations: true, invalidateDocumentSecurity: true } } });
  }, [invalidateCache]);

  return (
    <InvalidateCacheComponent
      onInvalidateCredentials={handleInvalidateCredentials}
      onInvalidateConfigurations={handleInvalidateConfigurations}
      invalidateCredentialsDisabled={invalidateCredentialsDisabled}
      invalidateConfigurationsDisabled={invalidateConfigurationsDisabled}
    />
  );
};

export default InvalidateCacheContainer;
